import { CommonModule } from '@angular/common';
import { HttpClientJsonpModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { BULK_SELECTED_FOLDERABLES_OPERATION_SLICE_KEY, bulkSelectedFolderablesOperation, } from 'FoldersApp/state/bulk-selected-folderables/bulk-selected-folderables-operation.reducer';
import { FOLDERABLE_OPERATION_SLICE_KEY, folderableOperation, } from 'FoldersApp/state/folderable-operation/folderable-operation.reducer';
import { SELECTED_FOLDERABLE_OPERATION_SLICE_KEY, selectedFolderableOperation, } from 'FoldersApp/state/selected-folder-item/selected-folderable-operation.reducer';
import { ConfigModule } from 'Angular/config/config.module';
import { SimpleDropdownModule } from 'Angular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { CheckboxGroupModule } from 'Angular/features/components/inputs/checkbox-group/checkbox-group.module';
import { LoadingSymbolModule } from 'Angular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { PromptModalModule } from 'Angular/features/components/modals/prompt-modal/prompt-modal.module';
import { SharingModalModule } from 'Angular/features/components/modals/sharing-modal/sharing-modal.module';
import { TemplateModalModule } from 'Angular/features/components/modals/template-modal/template-modal.module';
import { OpenItemModalModule } from 'Angular/features/components/saved-items/open-item-modal/open-item-modal.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { InfiniteScrollModule } from 'Angular/features/directives/infinite-scroll/infinite-scroll.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';
import { GetOwnerDisplayNamePipeModule } from 'SharingApp/ts/pipes/get-owner-display-name.module';
import { GetSharingTooltipMessagePipeModule } from 'SharingApp/ts/pipes/get-sharing-tooltip-message.module';
import { IsSharedWithOthersPipeModule } from 'SharingApp/ts/pipes/is-shared-with-others-pipe.module';
import { DeleteModalComponent } from 'Angular/features/components/delete-modal/delete-modal.component';
import { RenameModalComponent } from 'Angular/features/components/rename-modal/rename-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class FoldersSharedModule {
}
FoldersSharedModule.ɵfac = function FoldersSharedModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FoldersSharedModule)(); };
FoldersSharedModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FoldersSharedModule });
FoldersSharedModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [
        // Jsonp module must be imported before ConfigModule to
        // prevent X-CSRFToken header from being included in
        // jsonp requests https://github.com/angular/angular/issues/47312
        HttpClientJsonpModule,
        BaseAutocompleteModule,
        BrowserModule,
        CheckboxGroupModule,
        CommonModule,
        ConfigModule,
        DeleteModalComponent,
        DisabledModule,
        FormsModule,
        FormsModule,
        GetOwnerDisplayNamePipeModule,
        GetSharingTooltipMessagePipeModule,
        IconModule,
        InfiniteScrollModule,
        IsSharedWithOthersPipeModule,
        LoadingSymbolModule,
        ModalBaseModule,
        OpenItemModalModule,
        PromptModalModule,
        ReactiveFormsModule,
        RenameModalComponent,
        SharingModalModule,
        SimpleDropdownModule,
        StoreModule.forFeature(BULK_SELECTED_FOLDERABLES_OPERATION_SLICE_KEY, bulkSelectedFolderablesOperation),
        StoreModule.forFeature(FOLDERABLE_OPERATION_SLICE_KEY, folderableOperation),
        StoreModule.forFeature(SELECTED_FOLDERABLE_OPERATION_SLICE_KEY, selectedFolderableOperation),
        TemplateModalModule,
        TooltipModule] });
